import React from "react";
import moment from "moment";

export const DatosAlmacenInventario = ({ datosAlmacen }) => {
    return (
        <div className="mb-3">
            {datosAlmacen && (
                <React.Fragment>
                    <h3 className="text-center">Datos de almacén</h3>
                    <div className="formulario-fields-row">
                        <div className="formulario-field">
                            <label className="text-center">Nombre</label>
                            <span className="text-center">
                                {datosAlmacen.nombre_almacen}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">Materia prima</label>
                            <span className="text-center">
                                {datosAlmacen.materia_prima}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">
                                Última fecha inventariado
                            </label>
                            <span className="text-center">
                                {datosAlmacen.ultima_fecha_inventariado
                                    ? moment(
                                          datosAlmacen.ultima_fecha_inventariado,
                                      ).format("DD/MM/YYYY")
                                    : ""}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">Acopio</label>
                            <span className="text-center">
                                {datosAlmacen.nombre_acopio}
                            </span>
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};
